import { Capacitor } from "@capacitor/core";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { Typography, Box, Container, Stack, IconButton, Button } from "@mui/material";
import { useNavigate } from "react-router";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <Container maxWidth="md" sx={{ py: 4, paddingTop: Capacitor.isNativePlatform() ? "var(--safe-area-inset-top)" : 0, mt: 2 }}>
      <Button startIcon={<ArrowLeftIcon className="size24" />} sx={{ mb: 2 }} onClick={() => navigate(-1)}>
        Takaisin
      </Button>
      <Typography variant="h4" component="h1" gutterBottom>
        Tietosuojaseloste
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" gutterBottom>
        Päivitetty: 19.6.2025
      </Typography>

      <Typography variant="body1" paragraph>
        <b>ilmo.</b> on tapahtumien järjestämiseen erityisesti joukkueille ja harrasteryhmille tarkoitettu palvelu, joka helpottaa arkea ja yhdistää ihmisiä. Otamme yksityisyytesi vakavasti ja käsittelemme henkilötietoja vastuullisesti.
      </Typography>

      <Stack sx={{ mt: 4 }} spacing={3}>
        <Stack spacing={1}>
          <Typography variant="h6" gutterBottom>
            1. Rekisterinpitäjä
          </Typography>
          <Typography variant="body1" paragraph>
            ilmo.<br />
            Sähköposti: <b>ilmo@ilmo.online</b>
          </Typography>
        </Stack>

        <Stack spacing={1}>
          <Typography variant="h6" gutterBottom>
            2. Rekisteröidyt
          </Typography>
          <Typography variant="body1" paragraph>
            Rekisterissä ovat ilmon kirjautuneet käyttäjät.
          </Typography>
        </Stack>

        <Stack spacing={1}>
          <Typography variant="h6" gutterBottom>
            3. Henkilötiedot, joita kerätään
          </Typography>
          <Typography variant="body1" paragraph>
            ilmo. tallentaa seuraavat käyttäjätiedot:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
            <li>Sähköpostiosoite</li>
            <li>Nimi (Google ja Apple kirjautumisessa)</li>
            <li>Käyttäjänimi</li>
            <li>Käyttäjäkuvake (avatar)</li>
          </Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="h6" gutterBottom>
            4. Tietojen käyttötarkoitus
          </Typography>
          <Typography variant="body1" paragraph>
            Tietoja käytetään seuraaviin tarkoituksiin:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
            <li>Käyttäjätilin ylläpito ja tunnistaminen</li>
            <li>Ryhmätoiminnan mahdollistaminen</li>
            <li>Palvelun toiminnallisuuksien toteuttaminen ja kehittäminen</li>
            <li>Käyttäjäviestintä</li>
          </Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="h6" gutterBottom>
            5. Tietojen säilytys ja suojaus
          </Typography>
          <Typography variant="body1" paragraph>
            Henkilötiedot säilytetään vain niin kauan kuin se on tarpeellista palvelun tarjoamiseksi tai lainsäädännön vaatimusten täyttämiseksi. Tiedot suojataan pilvipalveluun, mihin ei ulkopuoliset pääse. Muut ilmon käyttäjät ketkä jakavat kanssasi samoja ryhmiä tai tapahtumia, näkevät käyttäjänimesi ja avatarisi. Muille käyttäjille ei näitäkään jaeta.
          </Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="h6" gutterBottom>
            6. Käyttäjän oikeudet
          </Typography>
          <Typography variant="body1" paragraph>
            Käyttäjällä on oikeus:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
            <li>Tarkastaa itseään koskevat tiedot</li>
            <li>Pyytää tietojensa oikaisua tai poistamista</li>
            <li>Vastustaa tietojen käsittelyä lain edellyttämissä rajoissa</li>
          </Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="h6" gutterBottom>
            7. Tietojen poistaminen
          </Typography>
          <Typography variant="body1" paragraph>
            Käyttäjä voi poistaa omat tietonsa:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
            <li>Kirjautumalla sisään ja siirtymällä kohtaan Asetukset {'>'} Poista käyttäjä</li>
            <li>Ottamalla yhteyttä sähköpostitse osoitteeseen: <b>ilmo@ilmo.online</b></li>
          </Typography>
        </Stack>

        <Stack spacing={1}>
          <Typography variant="h6">
            8. Tietojen luovutus ja siirto
          </Typography>
          <Typography variant="body1" paragraph>
            Tietoja ei luovuteta ulkopuolisille ilman käyttäjän suostumusta, ellei laki toisin vaadi. Tietoja ei siirretä EU:n tai ETA:n ulkopuolelle.
          </Typography>
        </Stack>

        <Stack spacing={1}>
          <Typography variant="h6">
            9. Muutokset tietosuojaselosteeseen
          </Typography>
          <Typography variant="body1" paragraph>
            ilmo. pidättää oikeuden päivittää tätä selostetta. Merkittävistä muutoksista ilmoitetaan käyttäjille palvelun kautta tai sähköpostitse.
          </Typography>
        </Stack>
      </Stack>
    </Container>
  );
}